export default "__VITE_ASSET__B$g6uQyA__"